var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"cgu"},[_c('v-card-text',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.CONSTANTS.ADD_ERROR)}})]),_c('v-card-actions',[_c('v-btn',{attrs:{"default":""},on:{"click":_vm.close}},[_vm._v("OK")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }